import { P2GBox } from '@parcel2go/peacock-legacy-core/dist/box';
import { P2GButton } from '@parcel2go/peacock-legacy-core/dist/button';
import { P2GDivider } from '@parcel2go/peacock-legacy-core/dist/divider';
import { P2GGrid } from '@parcel2go/peacock-legacy-core/dist/grid';
import { P2GCdnIcon } from '@parcel2go/peacock-legacy-core/dist/icons';
import SvgSmartSend from '@parcel2go/peacock-legacy-core/dist/icons/svg/SmartSend';
import SvgRuleWand from '@parcel2go/peacock-legacy-core/dist/icons/svg/RuleWand';
import { P2GLink } from '@parcel2go/peacock-legacy-core/dist/link';
import { P2GLinkGroup } from '@parcel2go/peacock-legacy-core/dist/linkgroup';
import { P2GText } from '@parcel2go/peacock-legacy-core/dist/typography';
import React from 'react';
import { Settings } from '../settings';
import { NotificationModel } from './AccountNotifications';

interface props {
  notification: NotificationModel;
  onClose: () => void;
}

const AccountNotificationWhatsNext: React.FC<props> = (props) => {
  if (
    props.notification?.integrationType === 'Marketplace' &&
    props.notification?.status == 'Active' &&
    props.notification?.success &&
    props.notification?.action === 'Install'
  ) {
    return (
      <P2GBox p={3} bordered>
        <P2GBox mb={2}>
          <P2GText variant="h4">What's next?</P2GText>
          <P2GText component="p">After you've linked your account, what next?</P2GText>
        </P2GBox>
        <P2GGrid container spacing={4}>
          {Settings.settings.links['SmartSend'] && (
            <>
              <P2GGrid item>
                <P2GGrid container spacing={1}>
                  <P2GGrid item>
                    <P2GCdnIcon size="lg" pallet="secondary" src="/theme/icons/SmartSend.svg">
                      <SvgSmartSend />
                    </P2GCdnIcon>
                  </P2GGrid>
                  <P2GGrid item>
                    <P2GText variant="h5">Get started...</P2GText>
                    <P2GText component="p">Start sending your items by going to Smart Send.</P2GText>
                    <P2GBox mt={2}>
                      <P2GButton href={Settings.settings.links['SmartSend']} colour="primary">
                        View Items
                      </P2GButton>
                    </P2GBox>
                  </P2GGrid>
                </P2GGrid>
              </P2GGrid>
            </>
          )}
          {Settings.settings.links['RuleManager'] && (
            <>
              <P2GGrid item>
                <P2GGrid container spacing={1}>
                  <P2GGrid item>
                    <P2GCdnIcon size="lg" pallet="secondary" src="/theme/icons/RuleWand.svg">
                      <SvgRuleWand />
                    </P2GCdnIcon>
                  </P2GGrid>
                  <P2GGrid item>
                    <P2GText variant="h5">Set some rules...</P2GText>
                    <P2GText component="p">Control how your items are imported with the Rule Manager.</P2GText>
                    <P2GBox mt={2}>
                      <P2GButton href={Settings.settings.links['RuleManager']} colour="secondary">
                        Create Rules
                      </P2GButton>
                    </P2GBox>
                  </P2GGrid>
                </P2GGrid>
              </P2GGrid>
            </>
          )}
        </P2GGrid>
      </P2GBox>
    );
  }

  return null;
};

export default AccountNotificationWhatsNext;
